export enum TimeFrameStatus {
  UPCOMING = 'Demnächst',
  WITHIN = 'Aktuell',
  PAST = 'Vergangen'
}
